export default __webpack_public_path__ + "static/media/gallery_09.4b979d52.jpg";